module.exports = __webpack_public_path__ + "static/media/jamie-sparker-music-videos.a17cdf4f.png";